import FormattedMessage from 'I18n/components/FormattedMessage';
import OwnerName from 'automation-ui-references/customer-data/OwnerName';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import * as InternalPropertyDefaults from 'automation-ui-action-features/object-type-properties/InternalPropertyDefaults';
import getPropertyAssignmentValue from 'automation-ui-action-features/actions/create-object/utils/getPropertyAssignmentValue';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateObjectOwnerLabel({
  metadata,
  flowObjectTypeId
}) {
  const ownerPropertyAssignment = getPropertyAssignmentValue(InternalPropertyDefaults.HUBSPOT_OWNER, metadata);
  if (!flowObjectTypeId) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  if (ownerPropertyAssignment && ownerPropertyAssignment.type !== PropertyValueTypes.MULTI_VALUE) {
    if (ownerPropertyAssignment.type !== PropertyValueTypes.STATIC_VALUE) {
      return /*#__PURE__*/_jsx(PropertyName, {
        propertyName: ownerPropertyAssignment.propertyName,
        objectTypeId: flowObjectTypeId
      });
    } else if (ownerPropertyAssignment.value) {
      // STATIC_VALUE types are NEVER arrays
      const value = Array.isArray(ownerPropertyAssignment.value) ? '' : ownerPropertyAssignment.value;
      return /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(OwnerName, {
          id: value,
          href: null
        })
      });
    }
  }
  return /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.create-object.noOwnerAssignment"
    })
  });
}